import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import type { TextTitledBodyData } from "@/types/storyboard";
import { resolveDialogueContent } from "@/components/storyboard/text/utils/resolveDialogueContent";

interface Props {
  data: TextTitledBodyData | string;
}

export const TextDialogue = ({ data }: Props) => {
  const { title, parts } = resolveDialogueContent(data);

  return (
    <ContentBlock title={title ?? undefined}>
      <div className="flex flex-col gap-3">
        {parts.map((part, index) => {
          if (part.type === "prose") {
            return (
              <p
                key={index}
                className="text-base font-semibold text-muted-foreground mb-6"
              >
                <CourseMarkdown>{part.content}</CourseMarkdown>
              </p>
            );
          }

          const isLeft = part.side === "left";
          return (
            <div
              key={index}
              className={`flex ${isLeft ? "justify-start" : "justify-end"}`}
            >
              <div
                className={`flex max-w-[75%] flex-col gap-0.5 ${isLeft ? "items-start" : "items-end"}`}
              >
                <span
                  className={`text-base font-semibold text-primary ${isLeft ? "" : "text-right"}`}
                >
                  {part.speaker}
                </span>
                <div
                  className={`rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${
                    isLeft
                      ? "rounded-tl-sm bg-primary text-white"
                      : "rounded-tr-sm bg-info-light text-black border border-primary/20"
                  }`}
                >
                  <CourseMarkdown>{part.content}</CourseMarkdown>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ContentBlock>
  );
};
